import { render, staticRenderFns } from "./productResearch.vue?vue&type=template&id=3553b1c4&"
import script from "./productResearch.vue?vue&type=script&lang=js&"
export * from "./productResearch.vue?vue&type=script&lang=js&"
import style0 from "./productResearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports